import { useMutation } from "react-query";
import templateFormHistoryService from "../../services/templateFormHistoryService";

const useDeleteTemplateFormHistoryAttachment = () => useMutation(templateFormHistoryService.deleteHistoricAttachment)

export default useDeleteTemplateFormHistoryAttachment;